import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

function OrdersOverviewChart() {
  const data = {
    labels: ['Order Completed', 'Order Unpaid', 'Order Returned', 'Order Pending', 'Order Canceled', 'Order Lost'],
    datasets: [
      {
        data: [45, 15, 10, 15, 10, 5],
        backgroundColor: [
          '#4c84ff', // Order Completed
          '#80e1c1', // Order Unpaid
          '#ff7b7b', // Order Returned
          '#8061ef', // Order Pending
          '#ffc107', // Order Canceled
          '#c7c1ff', // Order Lost
        ],
        hoverBackgroundColor: [
          '#4c84ff',
          '#80e1c1',
          '#ff7b7b',
          '#8061ef',
          '#ffc107',
          '#c7c1ff',
        ],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    cutout: '80%', // Makes it a doughnut chart
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true,
      },
    },
  };

  return (
    <div style={{ position: 'relative', height: '200px' }}>
      <Doughnut data={data} options={options} />
    </div>
  );
}

export default OrdersOverviewChart;
